/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * At least one of label or url must be provided
 * @export
 * @interface UpdateClaimLinkRequest
 */
export interface UpdateClaimLinkRequest {
    /**
     * Display label for the link
     * @type {string}
     * @memberof UpdateClaimLinkRequest
     */
    label?: string;
    /**
     * Full URL (must include protocol)
     * @type {string}
     * @memberof UpdateClaimLinkRequest
     */
    url?: string;
}

/**
 * Check if a given object implements the UpdateClaimLinkRequest interface.
 */
export function instanceOfUpdateClaimLinkRequest(value: object): value is UpdateClaimLinkRequest {
    return true;
}

export function UpdateClaimLinkRequestFromJSON(json: any): UpdateClaimLinkRequest {
    return UpdateClaimLinkRequestFromJSONTyped(json, false);
}

export function UpdateClaimLinkRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateClaimLinkRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
        'url': json['url'] == null ? undefined : json['url'],
    };
}

export function UpdateClaimLinkRequestToJSON(json: any): UpdateClaimLinkRequest {
    return UpdateClaimLinkRequestToJSONTyped(json, false);
}

export function UpdateClaimLinkRequestToJSONTyped(value?: UpdateClaimLinkRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
        'url': value['url'],
    };
}

